module.exports = __webpack_public_path__ + "img/cover_corona_heroi.aa7dcd76.jpg";